// import React, { useState, useEffect } from "react";
// import { Dropdown, Badge } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import "./ServitorNotificationPage.css";

// function getNotificationType(message = "") {
//   const msg = message.toLowerCase();
//   if (msg.includes("expiring")) return "urgent";
//   if (msg.includes("assigned") || msg.includes("order")) return "order";
//   if (msg.includes("maintenance") || msg.includes("system")) return "system";
//   if (msg.includes("review")) return "review";
//   if (msg.includes("payment") || msg.includes("balance")) return "payment";
//   return "default";
// }

// const ServitorNotificationDropdown = ({ servitorId }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         const response = await axios.get(
//           `http://localhost:4001/notifications/servitor/${servitorId}`
//         );
//         const data = response.data;
//         setNotifications(data);

//         // For demo, assume all are unread:
//         setUnreadCount(data.length);
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     if (servitorId) {
//       fetchNotifications();
//     }
//   }, [servitorId]);

//   return (
//     <Dropdown align="end">
//       <Dropdown.Toggle
//         variant="link"
//         id="ServitorNotificationDropdown-toggle"
//         className="ServitorNotificationDropdown-toggle"
//       >
//         <i className="bi bi-bell ServitorNotificationDropdown-bellIcon">
//           {unreadCount > 0 && (
//             <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//               {unreadCount}
//             </Badge>
//           )}
//         </i>
//       </Dropdown.Toggle>

//       <Dropdown.Menu className="ServitorNotificationDropdown-menu">
//         <Dropdown.Header className="ServitorNotificationDropdown-header">
//           Notifications
//         </Dropdown.Header>

//         {notifications.length === 0 ? (
//           <Dropdown.ItemText className="ServitorNotificationDropdown-empty">
//             No notifications
//           </Dropdown.ItemText>
//         ) : (
//           notifications.slice(0, 5).map((notif) => {
//             const notifType = getNotificationType(notif.message);
//             return (
//               <Dropdown.Item
//                 as={Link}
//                 to="/servitor/notifications"
//                 key={notif.id}
//                 className={`ServitorNotificationDropdown-item ${notifType}`}
//               >
//                 <div className="ServitorNotificationDropdown-itemIcon">
//                   {/* Example icons for different notification types */}
//                   {notifType === "urgent" && <i className="bi bi-exclamation-circle-fill text-danger"></i>}
//                   {notifType === "order" && <i className="bi bi-clipboard-check text-success"></i>}
//                   {notifType === "system" && <i className="bi bi-gear-fill text-warning"></i>}
//                   {notifType === "review" && <i className="bi bi-star-fill text-primary"></i>}
//                   {notifType === "payment" && <i className="bi bi-cash-stack text-success"></i>}
//                   {notifType === "default" && <i className="bi bi-bell-fill text-primary"></i>}
//                 </div>
//                 <div>
//                   <div className="ServitorNotificationDropdown-itemMessage">
//                     {notif.message}
//                   </div>
//                   <small className="text-muted">
//                     {new Date(notif.createdAt).toLocaleString()}
//                   </small>
//                 </div>
//               </Dropdown.Item>
//             );
//           })
//         )}

//         <Dropdown.Divider />

//         <Dropdown.Item
//           as={Link}
//           to="/servitor/notifications"
//           className="ServitorNotificationDropdown-viewAll"
//         >
//           View All Notifications
//         </Dropdown.Item>
//       </Dropdown.Menu>
//     </Dropdown>
//   );
// };

// export default ServitorNotificationDropdown;




// import React, { useState, useEffect } from "react";
// import { Dropdown, Badge } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import "./ServitorNotificationPage.css";

// function getNotificationType(message = "") {
//   const msg = message.toLowerCase();
//   if (msg.includes("expiring")) return "urgent";
//   if (msg.includes("assigned") || msg.includes("order")) return "order";
//   if (msg.includes("maintenance") || msg.includes("system")) return "system";
//   if (msg.includes("review")) return "review";
//   if (msg.includes("payment") || msg.includes("balance")) return "payment";
//   return "default";
// }

// const ServitorNotificationDropdown = ({ servitorId }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitorId) {
//           const response = await axios.get(
//             `http://localhost:4001/notifications/servitor/${servitorId}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Count unread notifications using the capitalized "isRead" field.
//           const count = data.filter((n) => !n.isRead).length;
//           setUnreadCount(count);
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
//   }, [servitorId]);

//   return (
//     <Dropdown align="end">
//       {/* <Dropdown.Toggle
//         variant="link"
//         id="ServitorNotificationDropdown-toggle"
//         className="ServitorNotificationDropdown-toggle"
//       >
//         <i className="bi bi-bell ServitorNotificationDropdown-bellIcon">
//           {unreadCount > 0 && (
//             <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//               {unreadCount}
//             </Badge>
//           )}
//         </i>
//       </Dropdown.Toggle> */}
//       <Dropdown.Toggle
//         variant="link"
//         id="ServitorNotificationDropdown-toggle"
//         className="ServitorNotificationDropdown-toggle"
//       >
//         {/* A wrapper div for positioning the bell icon & badge */}
//         <div className="ServitorNotificationDropdown-bellWrapper">
//           <i className="bi bi-bell ServitorNotificationDropdown-bellIcon" />
//           {unreadCount > 0 && (
//             <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//               {unreadCount}
//             </Badge>
//           )}
//         </div>
//       </Dropdown.Toggle>


//       <Dropdown.Menu className="ServitorNotificationDropdown-menu">
//         <Dropdown.Header className="ServitorNotificationDropdown-header">
//           Notifications
//         </Dropdown.Header>

//         {notifications.length === 0 ? (
//           <Dropdown.ItemText className="ServitorNotificationDropdown-empty">
//             No notifications
//           </Dropdown.ItemText>
//         ) : (
//           notifications.slice(0, 5).map((notif) => {
//             // Use the Notification's "type" field for styling
//             const notifType = getNotificationType(notif.message);
//             return (
//               <Dropdown.Item
//                 as={Link}
//                 to="/servitor/notifications"
//                 key={notif.Id}
//                 className={`ServitorNotificationDropdown-item ${notifType}`}
//               >
//                 <div className="ServitorNotificationDropdown-itemIcon">
//                   {notifType === "urgent" && (
//                     <i className="bi bi-exclamation-circle-fill text-danger"></i>
//                   )}
//                   {notifType === "order" && (
//                     <i className="bi bi-clipboard-check text-success"></i>
//                   )}
//                   {notifType === "system" && (
//                     <i className="bi bi-gear-fill text-warning"></i>
//                   )}
//                   {notifType === "review" && (
//                     <i className="bi bi-star-fill text-primary"></i>
//                   )}
//                   {notifType === "payment" && (
//                     <i className="bi bi-cash-stack text-success"></i>
//                   )}
//                   {notifType === "default" && (
//                     <i className="bi bi-bell-fill text-primary"></i>
//                   )}
//                 </div>
//                 <div>
//                   <div className="ServitorNotificationDropdown-itemMessage">
//                     {notif.message}
//                   </div>
//                   <small className="text-muted">
//                     {new Date(notif.created_at).toLocaleString()}
//                   </small>
//                 </div>
//               </Dropdown.Item>
//             );
//           })
//         )}

//         <Dropdown.Divider />

//         <Dropdown.Item
//           as={Link}
//           to="/servitor/notifications"
//           className="ServitorNotificationDropdown-viewAll"
//         >
//           View All Notifications
//         </Dropdown.Item>
//       </Dropdown.Menu>
//     </Dropdown>
//   );
// };

// export default ServitorNotificationDropdown;












// import React, { useState, useEffect } from "react";
// import { Dropdown, Badge } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import "./ServitorNotificationPage.css";

// // Function to get notification properties based on notification type
// function getNotificationProps(notif) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "bi bi-bell-fill",    // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     title: "Notification",       // fallback title
//   };

//   // If backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-circle-fill";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = "Deadline Warning (Pending)";
//       break;

//     case "order_cancelled":
//       props.borderClass = "order-cancelled";
//       props.iconClass = "bi bi-x-circle-fill";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       props.title = "Order Cancelled";
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-triangle-fill";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       props.title = "Deadline Warning";
//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-clock-fill";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       props.title = "Order Time Running Out";
//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       props.title = "Order In-Progress";
//       break;

//     case "order_completed":
//       props.borderClass = "order-completed";
//       props.iconClass = "bi bi-check-circle-fill";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       props.title = "Order Completed";
//       break;

//     // Fallback to message-based detection if type is not available
//     default:
//       const msg = notif.message?.toLowerCase() || "";
//       if (msg.includes("expiring")) {
//         props.borderClass = "urgent";
//         props.iconClass = "bi bi-exclamation-triangle-fill";
//         props.iconBgColor = "#fef5e6";
//         props.iconColor = "#f39c12";
//         props.title = "Deadline Warning";
//       } else if (msg.includes("assigned") || msg.includes("order")) {
//         props.borderClass = "order";
//         props.iconClass = "bi bi-clipboard-check";
//         props.iconBgColor = "#e6f7ed";
//         props.iconColor = "#2ecc71";
//         props.title = "Order Update";
//       } else if (msg.includes("maintenance") || msg.includes("system")) {
//         props.borderClass = "system";
//         props.iconClass = "bi bi-gear-fill";
//         props.iconBgColor = "#f8f9fa";
//         props.iconColor = "#6c757d";
//         props.title = "System Update";
//       } else if (msg.includes("review")) {
//         props.borderClass = "review";
//         props.iconClass = "bi bi-star-fill";
//         props.iconBgColor = "#e6f0ff";
//         props.iconColor = "#3498db";
//         props.title = "Review";
//       } else if (msg.includes("payment") || msg.includes("balance")) {
//         props.borderClass = "payment";
//         props.iconClass = "bi bi-cash-stack";
//         props.iconBgColor = "#e6ffed";
//         props.iconColor = "#27ae60";
//         props.title = "Payment";
//       }
//       break;
//   }

//   return props;
// }

// const ServitorNotificationDropdown = ({ servitorId }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [showAll, setShowAll] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitorId) {
//           const response = await axios.get(
//             `http://localhost:4001/notifications/servitor/${servitorId}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Count unread notifications using the capitalized "isRead" field.
//           const count = data.filter((n) => !n.isRead).length;
//           setUnreadCount(count);
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
    
//     // Polling for new notifications (optional)
//     const intervalId = setInterval(fetchNotifications, 60000); // Every minute
    
//     return () => clearInterval(intervalId);
//   }, [servitorId]);

//   const markAllAsRead = async (e) => {
//     e.stopPropagation();
//     try {
//       if (servitorId) {
//         await axios.put(
//           `http://localhost:4001/notifications/servitor/${servitorId}/mark-all-read`
//         );
        
//         // Update local state
//         setNotifications(prev => 
//           prev.map(notif => ({ ...notif, isRead: true }))
//         );
//         setUnreadCount(0);
//       }
//     } catch (error) {
//       console.error("Error marking notifications as read:", error);
//     }
//   };

//   const toggleShowAll = (e) => {
//     e.preventDefault();
//     setShowAll(!showAll);
//   };

//   // Format time relative to now (e.g., "5 minutes ago", "2 hours ago")
//   const formatRelativeTime = (dateString) => {
//     const now = new Date();
//     const date = new Date(dateString);
//     const diffMs = now - date;
//     const diffSec = Math.floor(diffMs / 1000);
//     const diffMin = Math.floor(diffSec / 60);
//     const diffHour = Math.floor(diffMin / 60);
//     const diffDay = Math.floor(diffHour / 24);

//     if (diffDay > 0) {
//       return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//     } else if (diffHour > 0) {
//       return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//     } else if (diffMin > 0) {
//       return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//     } else {
//       return "Just now";
//     }
//   };

//   return (
//     <Dropdown align="end"
//     show={dropdownOpen}
//     onToggle={(isOpen) => setDropdownOpen(isOpen)}>
//       <Dropdown.Toggle
//         variant="link"
//         id="ServitorNotificationDropdown-toggle"
//         className="ServitorNotificationDropdown-toggle"
//       >
//         <div className="ServitorNotificationDropdown-bellWrapper">
//           <i className="bi bi-bell ServitorNotificationDropdown-bellIcon" />
//           {unreadCount > 0 && (
//             <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//               {unreadCount > 99 ? "99+" : unreadCount}
//             </Badge>
//           )}
//         </div>
//       </Dropdown.Toggle>

//       <Dropdown.Menu className="ServitorNotificationDropdown-menu">
//         <div className="ServitorNotificationDropdown-header">
//           <div className="d-flex justify-content-between align-items-center">
//             <h6 className="mb-0">Notifications</h6>
//             {notifications.length > 0 && (
//               <button 
//                 className="ServitorNotificationDropdown-markAll" 
//                 onClick={markAllAsRead}
//               >
//                 Mark all as read
//               </button>
//             )}
//           </div>
//         </div>

//         <div className="ServitorNotificationDropdown-content">
//           {notifications.length === 0 ? (
//             <div className="ServitorNotificationDropdown-empty">
//               <div className="empty-icon">
//                 <i className="bi bi-inbox"></i>
//               </div>
//               <p>No notifications yet</p>
//             </div>
//           ) : (
//             <>
//               {notifications
//                 .slice(0, showAll ? notifications.length : 5)
//                 .map((notif) => {
//                   const props = getNotificationProps(notif);
//                   return (
//                     <Link
//                       to="/servitor/notifications"
//                       key={notif.Id}
//                       className={`ServitorNotificationDropdown-item ${props.borderClass} ${!notif.isRead ? 'unread' : ''}`}
//                     >
//                       <div 
//                         className="ServitorNotificationDropdown-itemIcon"
//                         style={{ 
//                           backgroundColor: props.iconBgColor,
//                         }}
//                       >
//                         <i 
//                           className={props.iconClass}
//                           style={{ color: props.iconColor }}
//                         ></i>
//                       </div>
//                       <div className="ServitorNotificationDropdown-itemContent">
//                         <div className="ServitorNotificationDropdown-itemTitle">
//                           {props.title}
//                         </div>
//                         <div className="ServitorNotificationDropdown-itemMessage">
//                           {notif.message}
//                         </div>
//                         <div className="ServitorNotificationDropdown-itemTime">
//                           {formatRelativeTime(notif.created_at)}
//                         </div>
//                       </div>
//                       {!notif.isRead && (
//                         <div className="ServitorNotificationDropdown-dot"></div>
//                       )}
//                     </Link>
//                   );
//                 })}

//               {notifications.length > 5 && (
//                 <div className="text-center my-2">
//                   <button 
//                     className="ServitorNotificationDropdown-showBtn"
//                     onClick={toggleShowAll}
//                   >
//                     {showAll ? 'Show Less' : `Show All (${notifications.length})`}
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         <div className="ServitorNotificationDropdown-footer">
//           <Link
//             to="/servitor/notifications"
//             className="ServitorNotificationDropdown-viewAll"
//           >
//             View All Notifications
//           </Link>
//         </div>
//       </Dropdown.Menu>
//     </Dropdown>
//   );
// };

// export default ServitorNotificationDropdown;



// ***** All is working fine, checked (26-6-25) ***** //
// import React, { useState, useEffect } from "react";
// import { Dropdown, Badge } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { URL } from "../../../config"; // Ensure this is set to your API base URL
// import "./ServitorNotificationPage.css";

// // Function to get notification properties based on notification type
// function getNotificationProps(notif) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "bi bi-bell-fill", // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     title: "Notification",       // fallback title
//   };

//   // If backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-circle-fill";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = "Deadline Warning (Pending)";
//       break;

//     case "order_cancelled":
//       props.borderClass = "order-cancelled";
//       props.iconClass = "bi bi-x-circle-fill";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       props.title = "Order Cancelled";
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-triangle-fill";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       props.title = "Deadline Warning";
//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-clock-fill";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       props.title = "Order Time Running Out";
//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       props.title = "Order In-Progress";
//       break;

//     case "order_completed":
//       props.borderClass = "order-completed";
//       props.iconClass = "bi bi-check-circle-fill";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       props.title = "Order Completed";
//       break;

//     // Fallback to message-based detection if type is not available
//     default:
//       const msg = notif.message?.toLowerCase() || "";
//       if (msg.includes("expiring")) {
//         props.borderClass = "urgent";
//         props.iconClass = "bi bi-exclamation-triangle-fill";
//         props.iconBgColor = "#fef5e6";
//         props.iconColor = "#f39c12";
//         props.title = "Deadline Warning";
//       } else if (msg.includes("assigned") || msg.includes("order")) {
//         props.borderClass = "order";
//         props.iconClass = "bi bi-clipboard-check";
//         props.iconBgColor = "#e6f7ed";
//         props.iconColor = "#2ecc71";
//         props.title = "Order Update";
//       } else if (msg.includes("maintenance") || msg.includes("system")) {
//         props.borderClass = "system";
//         props.iconClass = "bi bi-gear-fill";
//         props.iconBgColor = "#f8f9fa";
//         props.iconColor = "#6c757d";
//         props.title = "System Update";
//       } else if (msg.includes("review")) {
//         props.borderClass = "review";
//         props.iconClass = "bi bi-star-fill";
//         props.iconBgColor = "#e6f0ff";
//         props.iconColor = "#3498db";
//         props.title = "Review";
//       } else if (msg.includes("payment") || msg.includes("balance")) {
//         props.borderClass = "payment";
//         props.iconClass = "bi bi-cash-stack";
//         props.iconBgColor = "#e6ffed";
//         props.iconColor = "#27ae60";
//         props.title = "Payment";
//       }
//       break;
//   }

//   return props;
// }

// const ServitorNotificationDropdown = ({ servitorId }) => {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [showAll, setShowAll] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitorId) {
//           const response = await axios.get(
//             `${URL}/notifications/servitor/${servitorId}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Count unread notifications based on the "isRead" field
//           const count = data.filter((n) => !n.isRead).length;
//           setUnreadCount(count);
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
    
//     // Polling for new notifications every minute
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, [servitorId]);

//   // Function to mark a single notification as read
//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const response = await axios.patch(`${URL}/notifications/${notificationId}/read`);
//       if (response.status === 200) {
//         // Update local state: mark this notification as read
//         setNotifications((prev) =>
//           prev.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//         setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Mark all notifications as read
//   const markAllAsRead = async (e) => {
//     e.stopPropagation();
//     try {
//       const unreadNotifications = notifications.filter((notif) => !notif.isRead);
//       // Call the read endpoint for each unread notification
//       await Promise.all(
//         unreadNotifications.map((notif) =>
//           axios.patch(`${URL}/notifications/${notif.Id}/read`)
//         )
//       );
//       // Update local state: mark all as read
//       setNotifications((prev) =>
//         prev.map((notif) => ({ ...notif, isRead: true }))
//       );
//       setUnreadCount(0);
//       setDropdownOpen(false); // Close the dropdown after marking all as read
//     } catch (error) {
//       console.error("Error marking all notifications as read:", error);
//     }
//   };

//   const toggleShowAll = (e) => {
//     e.preventDefault();
//     setShowAll(!showAll);
//   };

//   // Format time relative to now (e.g., "5 minutes ago", "2 hours ago")
//   const formatRelativeTime = (dateString) => {
//     const now = new Date();
//     const date = new Date(dateString);
//     const diffMs = now - date;
//     const diffSec = Math.floor(diffMs / 1000);
//     const diffMin = Math.floor(diffSec / 60);
//     const diffHour = Math.floor(diffMin / 60);
//     const diffDay = Math.floor(diffHour / 24);

//     if (diffDay > 0) {
//       return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//     } else if (diffHour > 0) {
//       return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//     } else if (diffMin > 0) {
//       return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//     } else {
//       return "Just now";
//     }
//   };

//   return (
//     <Dropdown
//       align="end"
//       show={dropdownOpen}
//       onToggle={(isOpen) => setDropdownOpen(isOpen)}
//     >
//       <Dropdown.Toggle
//         variant="link"
//         id="ServitorNotificationDropdown-toggle"
//         className="ServitorNotificationDropdown-toggle"
//       >
//         <div className="ServitorNotificationDropdown-bellWrapper">
//           <i className="bi bi-bell ServitorNotificationDropdown-bellIcon" />
//           {unreadCount > 0 && (
//             <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//               {unreadCount > 99 ? "99+" : unreadCount}
//             </Badge>
//           )}
//         </div>
//       </Dropdown.Toggle>

//       <Dropdown.Menu className="ServitorNotificationDropdown-menu">
//         <div className="ServitorNotificationDropdown-header">
//           <div className="d-flex justify-content-between align-items-center">
//             <h6 className="mb-0">Notifications</h6>
//             {notifications.length > 0 && (
//               <button 
//                 className="ServitorNotificationDropdown-markAll" 
//                 onClick={markAllAsRead}
//               >
//                 Mark all as read
//               </button>
//             )}
//           </div>
//         </div>

//         <div className="ServitorNotificationDropdown-content">
//           {notifications.length === 0 ? (
//             <div className="ServitorNotificationDropdown-empty">
//               <div className="empty-icon">
//                 <i className="bi bi-inbox"></i>
//               </div>
//               <p>No notifications yet</p>
//             </div>
//           ) : (
//             <>
//               {notifications
//                 .slice(0, showAll ? notifications.length : 5)
//                 .map((notif) => {
//                   const props = getNotificationProps(notif);
//                   return (
//                     <Link
//                       to="/servitor/notifications"
//                       key={notif.Id}
//                       className={`ServitorNotificationDropdown-item ${props.borderClass} ${!notif.isRead ? "unread" : ""}`}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         if (!notif.isRead) {
//                           markNotificationAsRead(notif.Id);
//                         }
//                         setDropdownOpen(false); // Close dropdown on click
//                       }}
//                     >
//                       <div 
//                         className="ServitorNotificationDropdown-itemIcon"
//                         style={{ backgroundColor: props.iconBgColor }}
//                       >
//                         <i 
//                           className={props.iconClass}
//                           style={{ color: props.iconColor }}
//                         ></i>
//                       </div>
//                       <div className="ServitorNotificationDropdown-itemContent">
//                         <div className="ServitorNotificationDropdown-itemTitle">
//                           {props.title}
//                         </div>
//                         <div className="ServitorNotificationDropdown-itemMessage">
//                           {notif.message}
//                         </div>
//                         <div className="ServitorNotificationDropdown-itemTime">
//                           {formatRelativeTime(notif.created_at)}
//                         </div>
//                       </div>
//                       {!notif.isRead && (
//                         <div className="ServitorNotificationDropdown-dot"></div>
//                       )}
//                     </Link>
//                   );
//                 })}

//               {notifications.length > 5 && (
//                 <div className="text-center my-2">
//                   <button 
//                     className="ServitorNotificationDropdown-showBtn"
//                     onClick={toggleShowAll}
//                   >
//                     {showAll ? "Show Less" : `Show All (${notifications.length})`}
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         <div className="ServitorNotificationDropdown-footer">
//           <Link
//             to="/servitor/notifications"
//             className="ServitorNotificationDropdown-viewAll"
//             onClick={() => setDropdownOpen(false)}
//           >
//             View All Notifications
//           </Link>
//         </div>
//       </Dropdown.Menu>
//     </Dropdown>
//   );
// };

// export default ServitorNotificationDropdown;

// ***** Upper Code All is working fine, checked (26-6-25) ***** //





// ***** Add Translator EN BN (26-6-25) ***** //

// import React, { useState, useEffect } from "react";
// import { Dropdown, Badge } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import "./ServitorNotificationPage.css";

// // Function to get notification properties based on notification type
// function getNotificationProps(notif, t) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "bi bi-bell-fill", // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     // title: "Notification",       // fallback title
//     title: t("notifications.notification_titles.default"),
//   };

//   // If backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-circle-fill";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       // props.title = "Deadline Warning (Pending)";
//       props.title = t("notifications.notification_titles.deadline_warning_pending");
//       break;

//     case "order_cancelled":
//       props.borderClass = "order-cancelled";
//       props.iconClass = "bi bi-x-circle-fill";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       // props.title = "Order Cancelled";
//       props.title = t("notifications.notification_titles.order_cancelled");
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-triangle-fill";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       // props.title = "Deadline Warning";
//       props.title = t("notifications.notification_titles.deadline_warning");

//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-clock-fill";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       // props.title = "Order Time Running Out";
//       props.title = t("notifications.notification_titles.order_time_warning");

//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       // props.title = "Order In-Progress";
//       props.title = t("notifications.notification_titles.order_in_progress");

//       break;

//     case "order_completed":
//       props.borderClass = "order-completed";
//       props.iconClass = "bi bi-check-circle-fill";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       // props.title = "Order Completed";
//       props.title = t("notifications.notification_titles.order_completed");

//       break;

//     case "penalty_applied":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-circle-fill";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = t("notifications.notification_titles.penalty_applied");
//       break;

//     case "order_update":
//       props.borderClass = "order";
//       props.iconClass = "bi bi-clipboard-check";
//       props.iconBgColor = "#e6f7ed";
//       props.iconColor = "#2ecc71";
//       props.title = t("notifications.notification_titles.order_update");
//       break;

//     case "system":
//       props.borderClass = "system";
//       props.iconClass = "bi bi-gear-fill";
//       props.iconBgColor = "#f8f9fa";
//       props.iconColor = "#6c757d";
//       props.title = t("notifications.notification_titles.system");
//       break;

//     case "review":
//       props.borderClass = "review";
//       props.iconClass = "bi bi-star-fill";
//       props.iconBgColor = "#e6f0ff";
//       props.iconColor = "#3498db";
//       props.title = t("notifications.notification_titles.review");
//       break;

//     case "payment":
//       props.borderClass = "payment";
//       props.iconClass = "bi bi-cash-stack";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#27ae60";
//       props.title = t("notifications.notification_titles.payment");
//       break;

//     // Fallback to message-based detection if type is not available
//     default:
//       const msg = notif.message?.toLowerCase() || "";
//       if (msg.includes("expiring")) {
//         props.borderClass = "urgent";
//         props.iconClass = "bi bi-exclamation-triangle-fill";
//         props.iconBgColor = "#fef5e6";
//         props.iconColor = "#f39c12";
//         props.title = "Deadline Warning";
//       } else if (msg.includes("assigned") || msg.includes("order")) {
//         props.borderClass = "order";
//         props.iconClass = "bi bi-clipboard-check";
//         props.iconBgColor = "#e6f7ed";
//         props.iconColor = "#2ecc71";
//         props.title = "Order Update";
//       } else if (msg.includes("maintenance") || msg.includes("system")) {
//         props.borderClass = "system";
//         props.iconClass = "bi bi-gear-fill";
//         props.iconBgColor = "#f8f9fa";
//         props.iconColor = "#6c757d";
//         props.title = "System Update";
//       } else if (msg.includes("review")) {
//         props.borderClass = "review";
//         props.iconClass = "bi bi-star-fill";
//         props.iconBgColor = "#e6f0ff";
//         props.iconColor = "#3498db";
//         props.title = "Review";
//       } else if (msg.includes("payment") || msg.includes("balance")) {
//         props.borderClass = "payment";
//         props.iconClass = "bi bi-cash-stack";
//         props.iconBgColor = "#e6ffed";
//         props.iconColor = "#27ae60";
//         props.title = "Payment";
//       }
//       break;
//   }

//   return props;
// }


// // Function to parse and translate notification messages
// function parseNotificationMessage(notif, t) {
//   // Extract orderNumber and other dynamic parts from the message
//   const orderNumberMatch = notif.message.match(/order (\w+-\d+)/);
//   const orderNumber = orderNumberMatch ? orderNumberMatch[1] : notif.orderNumber || "Unknown";
  
//   // Extract penaltyAmount for penalty_applied notifications
//   const penaltyAmountMatch = notif.message.match(/A penalty of (\d+) taka/);
//   const penaltyAmount = penaltyAmountMatch ? penaltyAmountMatch[1] : "Unknown";

//   // Return translated message based on notification type
//   switch (notif.type) {
//     case "order_in_progress":
//       return t("notifications.notification_messages.order_in_progress", { orderNumber });
//     case "order_completed":
//       return t("notifications.notification_messages.order_completed", { orderNumber });
//     case "order_cancelled":
//       return t("notifications.notification_messages.order_cancelled", { orderNumber });
//     case "deadline_warning":
//       return t("notifications.notification_messages.deadline_warning", { orderNumber });
//     case "order_time_warning":
//       return t("notifications.notification_messages.order_time_warning", { orderNumber });
//     case "penalty_applied":
//       return t("notifications.notification_messages.penalty_applied", { orderNumber, penaltyAmount });
//     case "order_update":
//       return t("notifications.notification_messages.order_update", { orderNumber });
//     case "system":
//     case "review":
//     case "payment":
//       return t("notifications.notification_messages." + notif.type, { message: notif.message });
//     default:
//       return notif.message; // Fallback to original message if type is unknown
//   }
// }




// const ServitorNotificationDropdown = ({ servitorId }) => {
//   const { t } = useTranslation("servitor");
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [showAll, setShowAll] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitorId) {
//           const response = await axios.get(
//             `${URL}/notifications/servitor/${servitorId}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Count unread notifications based on the "isRead" field
//           const count = data.filter((n) => !n.isRead).length;
//           setUnreadCount(count);
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
    
//     // Polling for new notifications every minute
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, [servitorId]);

//   // Function to mark a single notification as read
//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const response = await axios.patch(`${URL}/notifications/${notificationId}/read`);
//       if (response.status === 200) {
//         // Update local state: mark this notification as read
//         setNotifications((prev) =>
//           prev.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//         setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Mark all notifications as read
//   const markAllAsRead = async (e) => {
//     e.stopPropagation();
//     try {
//       const unreadNotifications = notifications.filter((notif) => !notif.isRead);
//       // Call the read endpoint for each unread notification
//       await Promise.all(
//         unreadNotifications.map((notif) =>
//           axios.patch(`${URL}/notifications/${notif.Id}/read`)
//         )
//       );
//       // Update local state: mark all as read
//       setNotifications((prev) =>
//         prev.map((notif) => ({ ...notif, isRead: true }))
//       );
//       setUnreadCount(0);
//       setDropdownOpen(false); // Close the dropdown after marking all as read
//     } catch (error) {
//       console.error("Error marking all notifications as read:", error);
//     }
//   };

//   const toggleShowAll = (e) => {
//     e.preventDefault();
//     setShowAll(!showAll);
//   };

//   // Format time relative to now (e.g., "5 minutes ago", "2 hours ago")
//   // const formatRelativeTime = (dateString) => {
//   //   const now = new Date();
//   //   const date = new Date(dateString);
//   //   const diffMs = now - date;
//   //   const diffSec = Math.floor(diffMs / 1000);
//   //   const diffMin = Math.floor(diffSec / 60);
//   //   const diffHour = Math.floor(diffMin / 60);
//   //   const diffDay = Math.floor(diffHour / 24);

//   //   if (diffDay > 0) {
//   //     return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//   //   } else if (diffHour > 0) {
//   //     return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//   //   } else if (diffMin > 0) {
//   //     return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//   //   } else {
//   //     return "Just now";
//   //   }
//   // };

//   const formatRelativeTime = (dateString, t) => {
//   const now = new Date();
//   const date = new Date(dateString);
//   const diffMs = now - date;
//   const diffSec = Math.floor(diffMs / 1000);
//   const diffMin = Math.floor(diffSec / 60);
//   const diffHour = Math.floor(diffMin / 60);
//   const diffDay = Math.floor(diffHour / 24);

//   if (diffDay > 0) {
//     return diffDay === 1
//       ? t("notifications.time.one_day_ago")
//       : t("notifications.time.days_ago", { count: diffDay });
//   } else if (diffHour > 0) {
//     return diffHour === 1
//       ? t("notifications.time.one_hour_ago")
//       : t("notifications.time.hours_ago", { count: diffHour });
//   } else if (diffMin > 0) {
//     return diffMin === 1
//       ? t("notifications.time.one_minute_ago")
//       : t("notifications.time.minutes_ago", { count: diffMin });
//   } else {
//     return t("notifications.time.just_now");
//   }
// };

//   return (
//       <Dropdown
//         align="end"
//         show={dropdownOpen}
//         onToggle={(isOpen) => setDropdownOpen(isOpen)}
//       >
//         <Dropdown.Toggle
//           variant="link"
//           id="ServitorNotificationDropdown-toggle"
//           className="ServitorNotificationDropdown-toggle"
//         >
//           <div className="ServitorNotificationDropdown-bellWrapper">
//             <i className="bi bi-bell ServitorNotificationDropdown-bellIcon" />
//             {unreadCount > 0 && (
//               <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//                 {unreadCount > 99 ? "99+" : unreadCount}
//               </Badge>
//             )}
//           </div>
//         </Dropdown.Toggle>
  
//         <Dropdown.Menu className="ServitorNotificationDropdown-menu">
//           <div className="ServitorNotificationDropdown-header">
//             <div className="d-flex justify-content-between align-items-center">
//               <h6 className="mb-0">{t("notifications.page_title")}</h6>
//               {notifications.length > 0 && (
//                 <button 
//                   className="ServitorNotificationDropdown-markAll" 
//                   onClick={markAllAsRead}
//                 >
//                   {t("notifications.mark_all_read")}
//                 </button>
//               )}
//             </div>
//           </div>
  
//           <div className="ServitorNotificationDropdown-content">
//             {notifications.length === 0 ? (
//               <div className="ServitorNotificationDropdown-empty">
//                 <div className="empty-icon">
//                   <i className="bi bi-inbox"></i>
//                 </div>
//                 <p>{t("notifications.no_notifications")}</p>
//               </div>
//             ) : (
//               <>
//                 {notifications
//                   .slice(0, showAll ? notifications.length : 5)
//                   .map((notif) => {
//                     const props = getNotificationProps(notif, t);
//                     return (
//                       <Link
//                         to="/servitor/notifications"
//                         key={notif.Id}
//                         className={`ServitorNotificationDropdown-item ${props.borderClass} ${!notif.isRead ? "unread" : ""}`}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           if (!notif.isRead) {
//                             markNotificationAsRead(notif.Id);
//                           }
//                           setDropdownOpen(false); // Close dropdown on click
//                         }}
//                       >
//                         <div 
//                           className="ServitorNotificationDropdown-itemIcon"
//                           style={{ backgroundColor: props.iconBgColor }}
//                         >
//                           <i 
//                             className={props.iconClass}
//                             style={{ color: props.iconColor }}
//                           ></i>
//                         </div>
//                         <div className="ServitorNotificationDropdown-itemContent">
//                           <div className="ServitorNotificationDropdown-itemTitle">
//                             {props.title}
//                           </div>
//                           <div className="ServitorNotificationDropdown-itemMessage">
//                             {parseNotificationMessage(notif, t)}
//                           </div>
//                           <div className="ServitorNotificationDropdown-itemTime">
//                             {formatRelativeTime(notif.created_at, t)}
//                           </div>
//                         </div>
//                         {!notif.isRead && (
//                           <div className="ServitorNotificationDropdown-dot"></div>
//                         )}
//                       </Link>
//                     );
//                   })}
  
//                 {notifications.length > 5 && (
//                   <div className="text-center my-2">
//                     <button 
//                       className="ServitorNotificationDropdown-showBtn"
//                       onClick={toggleShowAll}
//                     >
//                       {showAll ? t("notifications.show_less") : t("notifications.show_all", { count: notifications.length })}
//                     </button>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
  
//           <div className="ServitorNotificationDropdown-footer">
//             <Link
//               to="/servitor/notifications"
//               className="ServitorNotificationDropdown-viewAll"
//               onClick={() => setDropdownOpen(false)}
//             >
//               {t("notifications.view_all_notifications")}
//             </Link>
//           </div>
//         </Dropdown.Menu>
//       </Dropdown>
//     );
//   };
  
// export default ServitorNotificationDropdown;





// ***** New Updated with notifications Sound (22-Sep-25) ***** //

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { Dropdown, Badge } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import "./ServitorNotificationPage.css";

// // >>> NEW: constants for ding tracking (separate key for servitor)
// const DING_STORAGE_KEY_SERVITOR = "dingedNotifIds_servitor_v1";
// const MAX_IDS_TO_KEEP = 300;

// // Function to get notification properties based on notification type
// function getNotificationProps(notif, t) {
//   // Default/fallback props
//   let props = {
//     borderClass: "",             // e.g. "urgent", "order", etc. for styling
//     iconClass: "bi bi-bell-fill", // default icon
//     iconBgColor: "#eef7ff",
//     iconColor: "#3498db",
//     // title: "Notification",       // fallback title
//     title: t("notifications.notification_titles.default"),
//   };

//   // If backend has a 'type' field, check that first:
//   switch (notif.type) {
//     case "deadline_warning_pending":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-circle-fill";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       // props.title = "Deadline Warning (Pending)";
//       props.title = t("notifications.notification_titles.deadline_warning_pending");
//       break;

//     case "order_cancelled":
//       props.borderClass = "order-cancelled";
//       props.iconClass = "bi bi-x-circle-fill";
//       props.iconBgColor = "#ffe6e6";
//       props.iconColor = "#d9534f";
//       // props.title = "Order Cancelled";
//       props.title = t("notifications.notification_titles.order_cancelled");
//       break;

//     case "deadline_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-triangle-fill";
//       props.iconBgColor = "#fef5e6";
//       props.iconColor = "#f39c12";
//       // props.title = "Deadline Warning";
//       props.title = t("notifications.notification_titles.deadline_warning");

//       break;

//     case "order_time_warning":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-clock-fill";
//       props.iconBgColor = "#fff7e6";
//       props.iconColor = "#f39c12";
//       // props.title = "Order Time Running Out";
//       props.title = t("notifications.notification_titles.order_time_warning");

//       break;

//     case "order_in_progress":
//       props.borderClass = "order";
//       props.iconClass = "fas fa-spinner";
//       props.iconBgColor = "#eef7ff";
//       props.iconColor = "#3498db";
//       // props.title = "Order In-Progress";
//       props.title = t("notifications.notification_titles.order_in_progress");

//       break;

//     case "order_completed":
//       props.borderClass = "order-completed";
//       props.iconClass = "bi bi-check-circle-fill";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#10b981";
//       // props.title = "Order Completed";
//       props.title = t("notifications.notification_titles.order_completed");

//       break;

//     case "penalty_applied":
//       props.borderClass = "urgent";
//       props.iconClass = "bi bi-exclamation-circle-fill";
//       props.iconBgColor = "#fef1f0";
//       props.iconColor = "#e74c3c";
//       props.title = t("notifications.notification_titles.penalty_applied");
//       break;

//     case "order_update":
//       props.borderClass = "order";
//       props.iconClass = "bi bi-clipboard-check";
//       props.iconBgColor = "#e6f7ed";
//       props.iconColor = "#2ecc71";
//       props.title = t("notifications.notification_titles.order_update");
//       break;

//     case "system":
//       props.borderClass = "system";
//       props.iconClass = "bi bi-gear-fill";
//       props.iconBgColor = "#f8f9fa";
//       props.iconColor = "#6c757d";
//       props.title = t("notifications.notification_titles.system");
//       break;

//     case "review":
//       props.borderClass = "review";
//       props.iconClass = "bi bi-star-fill";
//       props.iconBgColor = "#e6f0ff";
//       props.iconColor = "#3498db";
//       props.title = t("notifications.notification_titles.review");
//       break;

//     case "payment":
//       props.borderClass = "payment";
//       props.iconClass = "bi bi-cash-stack";
//       props.iconBgColor = "#e6ffed";
//       props.iconColor = "#27ae60";
//       props.title = t("notifications.notification_titles.payment");
//       break;

//     // Fallback to message-based detection if type is not available
//     default:
//       const msg = notif.message?.toLowerCase() || "";
//       if (msg.includes("expiring")) {
//         props.borderClass = "urgent";
//         props.iconClass = "bi bi-exclamation-triangle-fill";
//         props.iconBgColor = "#fef5e6";
//         props.iconColor = "#f39c12";
//         props.title = "Deadline Warning";
//       } else if (msg.includes("assigned") || msg.includes("order")) {
//         props.borderClass = "order";
//         props.iconClass = "bi bi-clipboard-check";
//         props.iconBgColor = "#e6f7ed";
//         props.iconColor = "#2ecc71";
//         props.title = "Order Update";
//       } else if (msg.includes("maintenance") || msg.includes("system")) {
//         props.borderClass = "system";
//         props.iconClass = "bi bi-gear-fill";
//         props.iconBgColor = "#f8f9fa";
//         props.iconColor = "#6c757d";
//         props.title = "System Update";
//       } else if (msg.includes("review")) {
//         props.borderClass = "review";
//         props.iconClass = "bi bi-star-fill";
//         props.iconBgColor = "#e6f0ff";
//         props.iconColor = "#3498db";
//         props.title = "Review";
//       } else if (msg.includes("payment") || msg.includes("balance")) {
//         props.borderClass = "payment";
//         props.iconClass = "bi bi-cash-stack";
//         props.iconBgColor = "#e6ffed";
//         props.iconColor = "#27ae60";
//         props.title = "Payment";
//       }
//       break;
//   }

//   return props;
// }


// // Function to parse and translate notification messages
// function parseNotificationMessage(notif, t) {
//   // Extract orderNumber and other dynamic parts from the message
//   const orderNumberMatch = notif.message.match(/order (\w+-\d+)/);
//   const orderNumber = orderNumberMatch ? orderNumberMatch[1] : notif.orderNumber || "Unknown";
  
//   // Extract penaltyAmount for penalty_applied notifications
//   const penaltyAmountMatch = notif.message.match(/A penalty of (\d+) taka/);
//   const penaltyAmount = penaltyAmountMatch ? penaltyAmountMatch[1] : "Unknown";

//   // Return translated message based on notification type
//   switch (notif.type) {
//     case "order_in_progress":
//       return t("notifications.notification_messages.order_in_progress", { orderNumber });
//     case "order_completed":
//       return t("notifications.notification_messages.order_completed", { orderNumber });
//     case "order_cancelled":
//       return t("notifications.notification_messages.order_cancelled", { orderNumber });
//     case "deadline_warning":
//       return t("notifications.notification_messages.deadline_warning", { orderNumber });
//     case "order_time_warning":
//       return t("notifications.notification_messages.order_time_warning", { orderNumber });
//     case "penalty_applied":
//       return t("notifications.notification_messages.penalty_applied", { orderNumber, penaltyAmount });
//     case "order_update":
//       return t("notifications.notification_messages.order_update", { orderNumber });
//     case "system":
//     case "review":
//     case "payment":
//       return t("notifications.notification_messages." + notif.type, { message: notif.message });
//     default:
//       return notif.message; // Fallback to original message if type is unknown
//   }
// }




// const ServitorNotificationDropdown = ({ servitorId }) => {
//   const { t } = useTranslation("servitor");
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [showAll, setShowAll] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);


//   // >>> NEW: audio + ding tracking (with persistence)
//     const audioRef = useRef(null);                 // >>> NEW
//     const dingedIdsRef = useRef(new Set());        // >>> NEW (IDs already dinged in this browser)
//     const bootstrappedRef = useRef(false);         // >>> NEW (skip ding on first poll)
  
//     // >>> NEW: hydrate dinged set from localStorage once
//     useEffect(() => {
//       try {
//         const raw = localStorage.getItem(DING_STORAGE_KEY_SERVITOR);
//         if (raw) {
//           const arr = JSON.parse(raw);
//           if (Array.isArray(arr)) arr.forEach((id) => dingedIdsRef.current.add(id));
//         }
//       } catch (_) {}
//     }, []);
  
//     // >>> NEW: stable ding function (ESLint-safe)
//     const playDing = useCallback(() => {
//       const el = audioRef.current;
//       if (!el) return;
//       el.currentTime = 0;
//       el.play().catch(() => {}); // ignore autoplay errors silently
//     }, []);
  
//     // >>> NEW: persist dinged IDs, capped to 300
//     const persistDingedIds = useCallback(() => {
//       const arr = Array.from(dingedIdsRef.current);
//       const trimmed = arr.slice(-MAX_IDS_TO_KEEP);
//       localStorage.setItem(DING_STORAGE_KEY_SERVITOR, JSON.stringify(trimmed));
//       if (trimmed.length !== arr.length) dingedIdsRef.current = new Set(trimmed);
//     }, []);
  

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       try {
//         if (servitorId) {
//           const response = await axios.get(
//             `${URL}/notifications/servitor/${servitorId}`
//           );
//           const data = response.data;
//           setNotifications(data);
//           // Count unread notifications based on the "isRead" field
//           const count = data.filter((n) => !n.isRead).length;
//           setUnreadCount(count);

//           // >>> NEW: ding-once-per-new-unread logic
//           const unreadNow = data.filter((n) => !n.isRead);
//           const dinged = dingedIdsRef.current;

//           if (!bootstrappedRef.current) {
//             // first poll after mount: record existing unread but don't play
//             unreadNow.forEach((n) => dinged.add(n.Id));
//             bootstrappedRef.current = true;
//             persistDingedIds();
//             return;
//           }

//           let shouldPlay = false;
//           for (const n of unreadNow) {
//             if (!dinged.has(n.Id)) {
//               shouldPlay = true;
//               dinged.add(n.Id);
//             }
//           }
//           if (shouldPlay) playDing();
//           persistDingedIds();
//         }
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       }
//     };

//     fetchNotifications();
    
//     // Polling for new notifications every minute
//     const intervalId = setInterval(fetchNotifications, 60000);
//     return () => clearInterval(intervalId);
//   }, [servitorId, playDing, persistDingedIds]);

//   // Function to mark a single notification as read
//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const response = await axios.patch(`${URL}/notifications/${notificationId}/read`);
//       if (response.status === 200) {
//         // Update local state: mark this notification as read
//         setNotifications((prev) =>
//           prev.map((notif) =>
//             notif.Id === notificationId ? { ...notif, isRead: true } : notif
//           )
//         );
//         setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
//       }
//     } catch (error) {
//       console.error("Error marking notification as read:", error);
//     }
//   };

//   // Mark all notifications as read
//   const markAllAsRead = async (e) => {
//     e.stopPropagation();
//     try {
//       const unreadNotifications = notifications.filter((notif) => !notif.isRead);
//       // Call the read endpoint for each unread notification
//       await Promise.all(
//         unreadNotifications.map((notif) =>
//           axios.patch(`${URL}/notifications/${notif.Id}/read`)
//         )
//       );
//       // Update local state: mark all as read
//       setNotifications((prev) =>
//         prev.map((notif) => ({ ...notif, isRead: true }))
//       );
//       setUnreadCount(0);
//       setDropdownOpen(false); // Close the dropdown after marking all as read
//     } catch (error) {
//       console.error("Error marking all notifications as read:", error);
//     }
//   };

//   const toggleShowAll = (e) => {
//     e.preventDefault();
//     setShowAll(!showAll);
//   };

//   // Format time relative to now (e.g., "5 minutes ago", "2 hours ago")
//   // const formatRelativeTime = (dateString) => {
//   //   const now = new Date();
//   //   const date = new Date(dateString);
//   //   const diffMs = now - date;
//   //   const diffSec = Math.floor(diffMs / 1000);
//   //   const diffMin = Math.floor(diffSec / 60);
//   //   const diffHour = Math.floor(diffMin / 60);
//   //   const diffDay = Math.floor(diffHour / 24);

//   //   if (diffDay > 0) {
//   //     return diffDay === 1 ? "1 day ago" : `${diffDay} days ago`;
//   //   } else if (diffHour > 0) {
//   //     return diffHour === 1 ? "1 hour ago" : `${diffHour} hours ago`;
//   //   } else if (diffMin > 0) {
//   //     return diffMin === 1 ? "1 minute ago" : `${diffMin} minutes ago`;
//   //   } else {
//   //     return "Just now";
//   //   }
//   // };

//   const formatRelativeTime = (dateString, t) => {
//   const now = new Date();
//   const date = new Date(dateString);
//   const diffMs = now - date;
//   const diffSec = Math.floor(diffMs / 1000);
//   const diffMin = Math.floor(diffSec / 60);
//   const diffHour = Math.floor(diffMin / 60);
//   const diffDay = Math.floor(diffHour / 24);

//   if (diffDay > 0) {
//     return diffDay === 1
//       ? t("notifications.time.one_day_ago")
//       : t("notifications.time.days_ago", { count: diffDay });
//   } else if (diffHour > 0) {
//     return diffHour === 1
//       ? t("notifications.time.one_hour_ago")
//       : t("notifications.time.hours_ago", { count: diffHour });
//   } else if (diffMin > 0) {
//     return diffMin === 1
//       ? t("notifications.time.one_minute_ago")
//       : t("notifications.time.minutes_ago", { count: diffMin });
//   } else {
//     return t("notifications.time.just_now");
//   }
// };

//   return (
//       <Dropdown
//         align="end"
//         show={dropdownOpen}
//         onToggle={(isOpen) => setDropdownOpen(isOpen)}
//       >

//          {/* >>> NEW: Hidden audio element */}
//       <audio ref={audioRef} preload="auto">
//         <source src="/sounds/notificationservitor.mp3" type="audio/mpeg" />
//       </audio>
      
//         <Dropdown.Toggle
//           variant="link"
//           id="ServitorNotificationDropdown-toggle"
//           className="ServitorNotificationDropdown-toggle"
//         >
//           <div className="ServitorNotificationDropdown-bellWrapper">
//             <i className="bi bi-bell ServitorNotificationDropdown-bellIcon" />
//             {unreadCount > 0 && (
//               <Badge bg="danger" className="ServitorNotificationDropdown-badge">
//                 {unreadCount > 99 ? "99+" : unreadCount}
//               </Badge>
//             )}
//           </div>
//         </Dropdown.Toggle>
  
//         <Dropdown.Menu className="ServitorNotificationDropdown-menu">
//           <div className="ServitorNotificationDropdown-header">
//             <div className="d-flex justify-content-between align-items-center">
//               <h6 className="mb-0">{t("notifications.page_title")}</h6>
//               {notifications.length > 0 && (
//                 <button 
//                   className="ServitorNotificationDropdown-markAll" 
//                   onClick={markAllAsRead}
//                 >
//                   {t("notifications.mark_all_read")}
//                 </button>
//               )}
//             </div>
//           </div>
  
//           <div className="ServitorNotificationDropdown-content">
//             {notifications.length === 0 ? (
//               <div className="ServitorNotificationDropdown-empty">
//                 <div className="empty-icon">
//                   <i className="bi bi-inbox"></i>
//                 </div>
//                 <p>{t("notifications.no_notifications")}</p>
//               </div>
//             ) : (
//               <>
//                 {notifications
//                   .slice(0, showAll ? notifications.length : 5)
//                   .map((notif) => {
//                     const props = getNotificationProps(notif, t);
//                     return (
//                       <Link
//                         to="/servitor/notifications"
//                         key={notif.Id}
//                         className={`ServitorNotificationDropdown-item ${props.borderClass} ${!notif.isRead ? "unread" : ""}`}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           if (!notif.isRead) {
//                             markNotificationAsRead(notif.Id);
//                           }
//                           setDropdownOpen(false); // Close dropdown on click
//                         }}
//                       >
//                         <div 
//                           className="ServitorNotificationDropdown-itemIcon"
//                           style={{ backgroundColor: props.iconBgColor }}
//                         >
//                           <i 
//                             className={props.iconClass}
//                             style={{ color: props.iconColor }}
//                           ></i>
//                         </div>
//                         <div className="ServitorNotificationDropdown-itemContent">
//                           <div className="ServitorNotificationDropdown-itemTitle">
//                             {props.title}
//                           </div>
//                           <div className="ServitorNotificationDropdown-itemMessage">
//                             {parseNotificationMessage(notif, t)}
//                           </div>
//                           <div className="ServitorNotificationDropdown-itemTime">
//                             {formatRelativeTime(notif.created_at, t)}
//                           </div>
//                         </div>
//                         {!notif.isRead && (
//                           <div className="ServitorNotificationDropdown-dot"></div>
//                         )}
//                       </Link>
//                     );
//                   })}
  
//                 {notifications.length > 5 && (
//                   <div className="text-center my-2">
//                     <button 
//                       className="ServitorNotificationDropdown-showBtn"
//                       onClick={toggleShowAll}
//                     >
//                       {showAll ? t("notifications.show_less") : t("notifications.show_all", { count: notifications.length })}
//                     </button>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
  
//           <div className="ServitorNotificationDropdown-footer">
//             <Link
//               to="/servitor/notifications"
//               className="ServitorNotificationDropdown-viewAll"
//               onClick={() => setDropdownOpen(false)}
//             >
//               {t("notifications.view_all_notifications")}
//             </Link>
//           </div>
//         </Dropdown.Menu>
//       </Dropdown>
//     );
//   };
  
// export default ServitorNotificationDropdown;








// ***** New update with loader and 10 data limit (19-Oct-2025) ***** //

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Dropdown, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";
import "./ServitorNotificationPage.css";

const DING_STORAGE_KEY_SERVITOR = "dingedNotifIds_servitor_v1";
const MAX_IDS_TO_KEEP = 300;

// ---- tiny helper to accept both old (array) and new (paginated) shapes
const normalizeNotifResponse = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

// ---- props builder (unchanged except for safe access)
function getNotificationProps(notif, t) {
  let props = {
    borderClass: "",
    iconClass: "bi bi-bell-fill",
    iconBgColor: "#eef7ff",
    iconColor: "#3498db",
    title: t("notifications.notification_titles.default"),
  };

  switch (notif.type) {
    case "deadline_warning_pending":
      props.borderClass = "urgent";
      props.iconClass = "bi bi-exclamation-circle-fill";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e74c3c";
      props.title = t("notifications.notification_titles.deadline_warning_pending");
      break;
    case "order_cancelled":
      props.borderClass = "order-cancelled";
      props.iconClass = "bi bi-x-circle-fill";
      props.iconBgColor = "#ffe6e6";
      props.iconColor = "#d9534f";
      props.title = t("notifications.notification_titles.order_cancelled");
      break;
    case "deadline_warning":
      props.borderClass = "urgent";
      props.iconClass = "bi bi-exclamation-triangle-fill";
      props.iconBgColor = "#fef5e6";
      props.iconColor = "#f39c12";
      props.title = t("notifications.notification_titles.deadline_warning");
      break;
    case "order_time_warning":
      props.borderClass = "urgent";
      props.iconClass = "bi bi-clock-fill";
      props.iconBgColor = "#fff7e6";
      props.iconColor = "#f39c12";
      props.title = t("notifications.notification_titles.order_time_warning");
      break;
    case "order_in_progress":
      props.borderClass = "order";
      props.iconClass = "fas fa-spinner";
      props.iconBgColor = "#eef7ff";
      props.iconColor = "#3498db";
      props.title = t("notifications.notification_titles.order_in_progress");
      break;
    case "order_completed":
      props.borderClass = "order-completed";
      props.iconClass = "bi bi-check-circle-fill";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.order_completed");
      break;
    case "penalty_applied":
      props.borderClass = "urgent";
      props.iconClass = "bi bi-exclamation-circle-fill";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e74c3c";
      props.title = t("notifications.notification_titles.penalty_applied");
      break;
    case "order_update":
      props.borderClass = "order";
      props.iconClass = "bi bi-clipboard-check";
      props.iconBgColor = "#e6f7ed";
      props.iconColor = "#2ecc71";
      props.title = t("notifications.notification_titles.order_update");
      break;
    case "system":
      props.borderClass = "system";
      props.iconClass = "bi bi-gear-fill";
      props.iconBgColor = "#f8f9fa";
      props.iconColor = "#6c757d";
      props.title = t("notifications.notification_titles.system");
      break;
    case "review":
      props.borderClass = "review";
      props.iconClass = "bi bi-star-fill";
      props.iconBgColor = "#e6f0ff";
      props.iconColor = "#3498db";
      props.title = t("notifications.notification_titles.review");
      break;
    case "payment":
      props.borderClass = "payment";
      props.iconClass = "bi bi-cash-stack";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#27ae60";
      props.title = t("notifications.notification_titles.payment");
      break;

    case "order_updated":
      props.borderClass = "order";
      props.iconClass = "bi bi-clipboard-check";   
      props.iconBgColor = "#e6f7ed";
      props.iconColor = "#2ecc71";
      props.title = t("notifications.notification_titles.order_updated");
      break;


      case "report_received": {
      // When *servitor* files a report, they get the auto-ack
      props.borderClass = "order"; // subtle blue border
      props.iconClass = "bi bi-life-preserver"; 
      props.iconBgColor = "#e6f0ff";
      props.iconColor = "#3498db";
      props.title = t("notifications.notification_titles.report_received");
      break;
    }

    case "report_opened_counterparty": {
      // When the *other side* (user) files a report, notify this servitor
      props.borderClass = "urgent"; // purple/red accent if you prefer
      props.iconClass = "bi bi-flag-fill";
      props.iconBgColor = "#f3e8ff";
      props.iconColor = "#7c3aed";
      props.title = t("notifications.notification_titles.report_opened_counterparty");
      break;
    }

    case "report_closed":
      props.borderClass = "order-completed";
      props.iconClass = "bi bi-life-preserver";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.report_closed");
      break;

    case "reward_points_awarded":
      props.borderClass = "order";
      props.iconClass = "bi bi-trophy-fill";
      props.iconBgColor = "#e6f0ff";
      props.iconColor = "#3b82f6";
      props.title = t("notifications.notification_titles.reward_points_awarded");
      break;

    case "discount_bonus":
      props.borderClass = "payment";
      props.iconClass = "bi bi-wallet2";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.discount_bonus");
      break;

    case "reward_claimed":
      props.borderClass = "payment";
      props.iconClass = "bi bi-wallet2";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.reward_claimed");
      break;

    case "account_blocked":
      props.borderClass = "urgent";
      props.iconClass = "bi bi-shield-lock-fill";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.account_blocked");
      break;

    case "referral_bonus":
      props.borderClass = "payment";
      props.iconClass = "fas fa-coins";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.referral_bonus");
      break;

    case "wallet_credit":
      props.borderClass = "payment";
      props.iconClass = "bi bi-wallet2";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.wallet_credit");
      break;

    case "order_assigned":
      props.borderClass = "order";
      props.iconClass = "bi bi-person-check-fill";
      props.iconBgColor = "#e6f7ed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.order_assigned");
      break;

    case "order_rescheduled":
      props.borderClass = "order";
      props.iconClass = "bi bi-calendar-event-fill";
      props.iconBgColor = "#eef7ff";
      props.iconColor = "#2563eb";
      props.title = t("notifications.notification_titles.order_rescheduled");
      break;

    case "account_approved":
      props.borderClass = "payment";
      props.iconClass = "bi bi-patch-check-fill";   // nice “approved” badge
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.account_approved");
      break;

    case "account_reapproved":
      props.borderClass = "system";
      props.iconClass = "bi bi-person-check-fill";
      props.iconBgColor = "#eef7ff";
      props.iconColor = "#2563eb";
      props.title = t("notifications.notification_titles.account_reapproved");
      break;
    
    case "account_approved_no_bonus":
      props.borderClass = "payment";
      props.iconClass = "bi bi-patch-check-fill";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.account_approved_no_bonus");
      break;

    case "account_blocked_admin":
      props.borderClass = "urgent";
      props.iconClass = "bi bi-shield-lock-fill";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.account_blocked_admin");
      break;


    case "tutor_user_approved":
      props.borderClass = "order";
      props.iconClass = "bi bi-person-check-fill";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#16a34a";
      props.title = t("notifications.notification_titles.tutor_user_approved");
      break;

    case "tutor_reassigned":
      props.borderClass = "order-cancelled";
      props.iconClass = "bi bi-arrow-left-right";
      props.iconBgColor = "#ffe6e6";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.tutor_reassigned");
      break;

    case "tutor_hired":
      props.borderClass = "order-completed";
      props.iconClass = "bi bi-briefcase-fill";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.tutor_hired");
      break;

    
    case "recharge_balance":
      props.borderClass = "payment";
      props.iconClass = "fas fa-wallet";
      props.iconBgColor = "#e6ffed";
      props.iconColor = "#10b981";
      props.title = t("notifications.notification_titles.recharge_balance");
      break;

    case "recharge_rejected":
      props.borderClass = "payment";
      props.iconClass = "fas fa-exclamation-circle";
      props.iconBgColor = "#fef1f0";
      props.iconColor = "#e11d48";
      props.title = t("notifications.notification_titles.recharge_rejected");
      break;




    
    default:
      break;
  }
  return props;
}


const parseAmount = (msg) => {
     const m = msg?.match(/[৳$]?\s*([0-9]+(?:\.[0-9]+)?)/);
     return m ? Number(m[1]) : undefined;
   };
   // helper: try to extract an admin note after an em dash (—) or hyphen
   const parseNote = (msg) => {
     if (!msg) return undefined;
     const byDash = msg.split("—");
     if (byDash.length > 1) return byDash.slice(1).join("—").trim().replace(/\.$/, "");
     const byHyphen = msg.split(" - ");
     if (byHyphen.length > 1) return byHyphen.slice(1).join(" - ").trim().replace(/\.$/, "");
     return undefined;
   };

// ---- safe parser
function parseNotificationMessage(notif, t) {
  const orderNumberMatch = notif.message?.match?.(/order (\w+-\d+)/);
  const orderNumber = orderNumberMatch ? orderNumberMatch[1] : notif.orderNumber || "Unknown";
  const penaltyAmountMatch = notif.message?.match?.(/A penalty of (\d+) taka/);
  const penaltyAmount = penaltyAmountMatch ? penaltyAmountMatch[1] : "Unknown";

  switch (notif.type) {
    case "order_in_progress":
      return t("notifications.notification_messages.order_in_progress", { orderNumber });
    case "order_completed":
      return t("notifications.notification_messages.order_completed", { orderNumber });
    case "order_cancelled":
      return t("notifications.notification_messages.order_cancelled", { orderNumber });
    case "deadline_warning":
      return t("notifications.notification_messages.deadline_warning", { orderNumber });
    case "order_time_warning":
      return t("notifications.notification_messages.order_time_warning", { orderNumber });
    case "penalty_applied":
      return t("notifications.notification_messages.penalty_applied", { orderNumber, penaltyAmount });
    case "order_update":
      return t("notifications.notification_messages.order_update", { orderNumber });
    case "system":
    case "review":
    case "payment":
      return t("notifications.notification_messages." + notif.type, { message: notif.message });
    
    case "order_updated": {
      // Try to get orderNumber from explicit field or from message text
      const ord =
        notif.orderNumber ||
        notif.message?.match?.(/order\s+([A-Z]+-\d+)/i)?.[1] ||
        "Unknown";

      // Try to parse minutes from backend message ("Time extended by 15 minute(s).")
      const m = notif.message?.match?.(/extended\s+by\s+(\d+)\s*minute/i);
      const minutes = m ? parseInt(m[1], 10) : undefined;

      return minutes
        ? t("notifications.notification_messages.order_updated_with_time", { orderNumber: ord, minutes })
        : t("notifications.notification_messages.order_updated", { orderNumber: ord });
    }


    case "report_received": {
      const orderNumber = notif.orderNumber || "Unknown";
      return t("notifications.notification_messages.report_received", { orderNumber });
    }

    case "report_opened_counterparty": {
      const orderNumber = notif.orderNumber || "Unknown";
      return t("notifications.notification_messages.report_opened_counterparty", { orderNumber });
    }

    case "report_closed": {
      const orderNumber = notif.orderNumber || "Unknown";
      // prefer explicit field; otherwise, try to parse from message
      const raw = notif.status || notif.message?.match?.(/\bis (\w+)\b/i)?.[1] || "resolved";
      const statusLabel = t(`notifications.status.${raw}`, raw);
      return t("notifications.notification_messages.report_closed", { orderNumber, status: statusLabel });
    }

    case "reward_claimed": {
     const claimAmount =
       typeof notif.claimAmount === "number"
         ? notif.claimAmount
         : (() => {
             const m = notif.message?.match?.(/(\d+)\s*tk/i);
             return m ? parseInt(m[1], 10) : undefined;
           })();
     return t("notifications.notification_messages.reward_claimed", { claimAmount });
   }

    case "reward_points_awarded": {
      // "Congrats! You earned 5 points for PS-1234."
      const count = (() => {
        const m = notif.message?.match?.(/earned\s+(\d+)\s+point/i);
        return m ? parseInt(m[1], 10) : undefined;
      })();
      const ord = (() => {
        // prefer explicit property, fall back to regex
        if (notif.orderNumber) return notif.orderNumber;
        const m = notif.message?.match?.(/for\s+([A-Z]+-\d+)/i);
        return m ? m[1] : "Unknown";
      })();
      return t("notifications.notification_messages.reward_points_awarded", {
        count,
        orderNumber: ord,
      });
    }

    case "discount_bonus": {
      // "Good news! You received an additional 40 taka bonus due to customer discount (BRONZE-123)."
      const amount = (() => {
        const m = notif.message?.match?.(/additional\s+(\d+)\s+taka/i);
        return m ? parseInt(m[1], 10) : undefined;
      })();
      const couponCode = (() => {
        const m = notif.message?.match?.(/\(([A-Za-z0-9-]+)\)/);
        return m ? m[1] : undefined;
      })();
      return t("notifications.notification_messages.discount_bonus", {
        amount,
        couponCode: couponCode || t("notifications.unknown"),
      });
   }

   case "account_blocked": {
    const orderNumber = notif.orderNumber || "Unknown";
    return t("notifications.notification_messages.account_blocked", { orderNumber });
  }

  case "referral_bonus": {
    const amt = (() => {
      const m = notif.message?.match(/[৳$]?\s*([0-9]+(?:\.[0-9]+)?)/);
      return m ? Number(m[1]) : undefined;
    })();
    const isSelf = /first\s+recharge/i.test(notif.message || "");
    return isSelf
      ? t("notifications.notification_messages.referral_bonus_self", { amount: amt })
      : t("notifications.notification_messages.referral_bonus_referrer", { amount: amt });
  }

  case "wallet_credit": {
       const amount = typeof notif.amount === "number" ? notif.amount : parseAmount(notif.message);
       const note = notif.note || parseNote(notif.message);
       const base = t("notifications.notification_messages.wallet_credit", { amount });
       return note ? `${base} ${t("notifications.note_prefix")}${note}` : base;
     }

     case "order_assigned": {
      const ord =
        notif.orderNumber ||
        notif.message?.match?.(/order\s+([A-Z]+-\d+)/i)?.[1] ||
        "Unknown";
      return t("notifications.notification_messages.order_assigned", { orderNumber: ord });
    }

    case "order_rescheduled": {
      const ord =
        notif.orderNumber ||
        notif.message?.match?.(/order\s+([A-Z]+-\d+)/i)?.[1] ||
        "Unknown";
      // backend message ends with: "... to ${whenText}."
      const whenMatch = notif.message?.match?.(/\bto\s+(.+?)\.?$/i);
      const whenText = notif.whenText || (whenMatch ? whenMatch[1] : undefined);
      return t("notifications.notification_messages.order_rescheduled", {
        orderNumber: ord,
        whenText: whenText || t("notifications.unknown"),
      });
    }

    case "account_approved": {
      const amount =
        typeof notif.amount === "number" ? notif.amount : parseAmount(notif.message);
      return t("notifications.notification_messages.account_approved", { amount });
    }

    case "account_approved_no_bonus":
      return t("notifications.notification_messages.account_approved_no_bonus");

    case "account_blocked_admin":
      return t("notifications.notification_messages.account_blocked_admin");


    case "account_reapproved":
      return t("notifications.notification_messages.account_reapproved");

    case "tutor_user_approved":
      return t("notifications.notification_messages.tutor_user_approved", { orderNumber });

    case "tutor_reassigned":
      return t("notifications.notification_messages.tutor_reassigned", { orderNumber });

    case "tutor_hired":
      return t("notifications.notification_messages.tutor_hired", { orderNumber });

    
    case "recharge_balance": {
      const amount =
        typeof notif.amount === "number"
          ? notif.amount
          : parseAmount(notif.message);
      return t("notifications.notification_messages.recharge_balance", {
        amount,
      });
    }

    case "recharge_rejected": {
      const amount =
        typeof notif.amount === "number"
          ? notif.amount
          : parseAmount(notif.message);
      return t("notifications.notification_messages.recharge_rejected", {
        amount,
      });
    }


    default:
      return notif.message || "";
  }
}

const ServitorNotificationDropdown = ({ servitorId }) => {
  const { t } = useTranslation("servitor");
  const [notifications, setNotifications] = useState([]); // keep this as ARRAY
  const [unreadCount, setUnreadCount] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const audioRef = useRef(null);
  const dingedIdsRef = useRef(new Set());
  const bootstrappedRef = useRef(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(DING_STORAGE_KEY_SERVITOR);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) arr.forEach((id) => dingedIdsRef.current.add(id));
      }
    } catch (_) {}
  }, []);

  const playDing = useCallback(() => {
    const el = audioRef.current;
    if (!el) return;
    el.currentTime = 0;
    el.play().catch(() => {});
  }, []);

  const persistDingedIds = useCallback(() => {
    const arr = Array.from(dingedIdsRef.current);
    const trimmed = arr.slice(-MAX_IDS_TO_KEEP);
    localStorage.setItem(DING_STORAGE_KEY_SERVITOR, JSON.stringify(trimmed));
    if (trimmed.length !== arr.length) dingedIdsRef.current = new Set(trimmed);
  }, []);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        if (!servitorId) return;

        // request only what we need for the dropdown
        const { data } = await axios.get(
          `${URL}/notifications/servitor/${servitorId}?page=1&limit=10`
        );

        const list = normalizeNotifResponse(data); // <-- normalize here
        setNotifications(list);

        const count = list.filter((n) => !n.isRead).length;
        setUnreadCount(count);

        // ding-once logic
        const unreadNow = list.filter((n) => !n.isRead);
        const dinged = dingedIdsRef.current;

        if (!bootstrappedRef.current) {
          unreadNow.forEach((n) => dinged.add(n.Id));
          bootstrappedRef.current = true;
          persistDingedIds();
          return;
        }

        let shouldPlay = false;
        for (const n of unreadNow) {
          if (!dinged.has(n.Id)) {
            shouldPlay = true;
            dinged.add(n.Id);
          }
        }
        if (shouldPlay) playDing();
        persistDingedIds();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 60000);
    return () => clearInterval(intervalId);
  }, [servitorId, playDing, persistDingedIds]);

  const markNotificationAsRead = async (notificationId) => {
    try {
      const response = await axios.patch(`${URL}/notifications/${notificationId}/read`);
      if (response.status === 200) {
        setNotifications((prev) =>
          prev.map((notif) => (notif.Id === notificationId ? { ...notif, isRead: true } : notif))
        );
        setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const markAllAsRead = async (e) => {
    e.stopPropagation();
    try {
      const unreadNotifications = notifications.filter((notif) => !notif.isRead);
      await Promise.all(
        unreadNotifications.map((notif) =>
          axios.patch(`${URL}/notifications/${notif.Id}/read`)
        )
      );
      setNotifications((prev) => prev.map((notif) => ({ ...notif, isRead: true })));
      setUnreadCount(0);
      setDropdownOpen(false);
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  };

  const toggleShowAll = (e) => {
    e.preventDefault();
    setShowAll((s) => !s);
  };

  const formatRelativeTime = (dateString, t) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);

    if (diffDay > 0) {
      return diffDay === 1
        ? t("notifications.time.one_day_ago")
        : t("notifications.time.days_ago", { count: diffDay });
    } else if (diffHour > 0) {
      return diffHour === 1
        ? t("notifications.time.one_hour_ago")
        : t("notifications.time.hours_ago", { count: diffHour });
    } else if (diffMin > 0) {
      return diffMin === 1
        ? t("notifications.time.one_minute_ago")
        : t("notifications.time.minutes_ago", { count: diffMin });
    } else {
      return t("notifications.time.just_now");
    }
  };

  return (
    <Dropdown align="end" show={dropdownOpen} onToggle={(isOpen) => setDropdownOpen(isOpen)}>
      {/* hidden audio for ding */}
      <audio ref={audioRef} preload="auto">
        <source src="/sounds/notificationservitor.mp3" type="audio/mpeg" />
      </audio>

      <Dropdown.Toggle
        variant="link"
        id="ServitorNotificationDropdown-toggle"
        className="ServitorNotificationDropdown-toggle"
      >
        <div className="ServitorNotificationDropdown-bellWrapper">
          <i className="bi bi-bell ServitorNotificationDropdown-bellIcon" />
          {unreadCount > 0 && (
            <Badge bg="danger" className="ServitorNotificationDropdown-badge">
              {unreadCount > 99 ? "99+" : unreadCount}
            </Badge>
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="ServitorNotificationDropdown-menu">
        <div className="ServitorNotificationDropdown-header">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="mb-0">{t("notifications.page_title")}</h6>
            {notifications.length > 0 && (
              <button className="ServitorNotificationDropdown-markAll" onClick={markAllAsRead}>
                {t("notifications.mark_all_read")}
              </button>
            )}
          </div>
        </div>

        <div className="ServitorNotificationDropdown-content">
          {notifications.length === 0 ? (
            <div className="ServitorNotificationDropdown-empty">
              <div className="empty-icon">
                <i className="bi bi-inbox"></i>
              </div>
              <p>{t("notifications.no_notifications")}</p>
            </div>
          ) : (
            <>
              {notifications
                .slice(0, showAll ? notifications.length : 5)
                .map((notif) => {
                  const props = getNotificationProps(notif, t);
                  return (
                    <Link
                      to="/servitor/notifications"
                      key={notif.Id}
                      className={`ServitorNotificationDropdown-item ${props.borderClass} ${
                        !notif.isRead ? "unread" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!notif.isRead) {
                          markNotificationAsRead(notif.Id);
                        }
                        setDropdownOpen(false);
                      }}
                    >
                      <div
                        className="ServitorNotificationDropdown-itemIcon"
                        style={{ backgroundColor: props.iconBgColor }}
                      >
                        <i className={props.iconClass} style={{ color: props.iconColor }}></i>
                      </div>
                      <div className="ServitorNotificationDropdown-itemContent">
                        <div className="ServitorNotificationDropdown-itemTitle">{props.title}</div>
                        <div className="ServitorNotificationDropdown-itemMessage">
                          {parseNotificationMessage(notif, t)}
                        </div>
                        <div className="ServitorNotificationDropdown-itemTime">
                          {formatRelativeTime(notif.created_at, t)}
                        </div>
                      </div>
                      {!notif.isRead && <div className="ServitorNotificationDropdown-dot"></div>}
                    </Link>
                  );
                })}

              {notifications.length > 5 && (
                <div className="text-center my-2">
                  <button className="ServitorNotificationDropdown-showBtn" onClick={toggleShowAll}>
                    {showAll
                      ? t("notifications.show_less")
                      : t("notifications.show_all", { count: notifications.length })}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        <div className="ServitorNotificationDropdown-footer">
          <Link
            to="/servitor/notifications"
            className="ServitorNotificationDropdown-viewAll"
            onClick={() => setDropdownOpen(false)}
          >
            {t("notifications.view_all_notifications")}
          </Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ServitorNotificationDropdown;
